import { shopMessages, type KnownShopLocale, type ShopMessageKey } from '../messages'
import { localeToLanguage, type ShopLocale } from '../shopLocale'
import type { TranslateParams } from './types'

const interpolate = (template: string, params: TranslateParams | undefined) => {
  if (!params) return template
  return template.replace(/\{([\w_]+)\}/g, (_, key: string) => {
    const value = params[key]
    return value === undefined || value === null ? '' : String(value)
  })
}

export const createTranslator = (locale: ShopLocale) => (key: ShopMessageKey, params?: TranslateParams) => {
  const translationLocale: KnownShopLocale = localeToLanguage(locale) === 'en' ? 'en-US' : 'it-IT'
  const template = shopMessages[translationLocale][key] ?? shopMessages['it-IT'][key] ?? key
  return interpolate(template, params)
}
